import React, { useState, useEffect } from 'react'
import { db } from '../firebase-config'
import { getDocs, collection, query, orderBy, limit } from 'firebase/firestore'
import { Link } from 'react-router-dom'
import { Button } from '../components/Button'
import { Entry } from '../components/Entry'
import styles from '../components/Entry.module.css'

const newsRef = collection(db, 'news')
const ordered = query(newsRef, orderBy('timestamp', 'desc'), limit(10))

export const News = ({ user }) => {
  const [news, setNews] = useState([])

  async function getNews() {
    const data = await getDocs(ordered)
    const parsedData = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    setNews(parsedData)
  }

  useEffect(() => {
    getNews()
  }, [])

  return (
    <div className={styles.newsContainer}>
      {!user ? (
        <>
          <p>Erstelle dir einen Shop, um eigene Einträge hinzuzufügen</p>
        </>
      ) : (
        <>
          <Link to="/create-news">
            <Button>Beitrag erstellen</Button>
          </Link>
        </>
      )}
      {news.map((entry) => (
        <Entry key={entry.id} entry={entry} user={user} />
      ))}
    </div>
  )
}
